import React from 'react';
import PropTypes from 'prop-types';

const MetaDataItem = ({ 'data-testid': testId, label, content, icon }) => {
  return (
    <div data-testid={testId}>
      <div data-testid={`${testId}-label`} className="text-sm text-secondary">
        {label}
      </div>
      <div className="flex items-center space-x-2">
        {icon}
        <div data-testid={`${testId}-content`} className="flex-1">
          {content}
        </div>
      </div>
    </div>
  );
};

MetaDataItem.propTypes = {
  'data-testid': PropTypes.string,
  label: PropTypes.string.isRequired,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  icon: PropTypes.node.isRequired,
};

MetaDataItem.defaultProps = {
  'data-testid': 'meta-data-item',
};

export default MetaDataItem;
